import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import RecipeCard from "@/components/RecipeCard";

const Stories = () => {
    const [recipes, setRecipes] = useState([]);

    useEffect(() => {
        api.get("/recipes", { params: { featured: true } })
            .then((r) => {
                const sorted = r.data.slice().sort((a, b) => {
                    const ea = a.episode ?? Number.POSITIVE_INFINITY;
                    const eb = b.episode ?? Number.POSITIVE_INFINITY;
                    return ea - eb;
                });
                setRecipes(sorted);
            })
            .catch(() => {});
    }, []);

    return (
        <div data-testid="stories-page" className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-32">
            <div className="max-w-3xl hl-fade-up">
                <p className="font-script text-3xl text-hl-secondary">taste the story —</p>
                <h1 className="font-serif text-5xl md:text-7xl text-hl-brown mt-2 leading-[1.02]">
                    The dishes that <span className="italic">made us</span>.
                </h1>
                <p className="mt-6 text-hl-muted text-lg leading-relaxed max-w-2xl">
                    Some recipes are too important to be told as a list of ingredients.
                    These are the dishes whose history we hold most carefully — Fasolada,
                    Agrelia me ta Avga, Rhodian Meatballs, Avgolemono — and the
                    grandmothers who first put them on our tables.
                </p>
            </div>

            <div className="mt-16 grid gap-12 md:gap-10 sm:grid-cols-2 lg:grid-cols-3">
                {recipes.map((r, i) => (
                    <RecipeCard key={r.id} recipe={r} index={i} />
                ))}
            </div>

            {recipes.length === 0 ? (
                <p className="text-hl-muted italic mt-16 font-serif text-2xl">
                    Stories are being prepared...
                </p>
            ) : null}

            <div className="mt-20 text-center">
                <Link
                    to="/recipes"
                    className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-hl-brown hl-link"
                >
                    See the full archive →
                </Link>
            </div>
        </div>
    );
};

export default Stories;
